/**
 * Show a Bootstrap toast notification
 * @param {string} type - Toast type (success, danger, warning, info)
 * @param {string} message - Toast message
 */
function showToast(type, message) {
    // Create toast container if it doesn't exist
    let toastContainer = document.getElementById('toast-container');
    if (!toastContainer) {
        toastContainer = document.createElement('div');
        toastContainer.id = 'toast-container';
        toastContainer.className = 'position-fixed top-0 end-0 p-3';
        toastContainer.style.zIndex = '1055';
        document.body.appendChild(toastContainer);
    }

    // Create toast element
    const toastId = 'toast-' + Date.now();
    const iconClass = type === 'success' ? 'fa-check-circle' : 
                     type === 'danger' ? 'fa-exclamation-triangle' : 
                     type === 'warning' ? 'fa-exclamation-triangle' : 
                     'fa-info-circle';
    
    const bgClass = type === 'success' ? 'text-bg-success' : 
                   type === 'danger' ? 'text-bg-danger' : 
                   type === 'warning' ? 'text-bg-warning' : 
                   'text-bg-info';

    const toastHtml = `
        <div id="${toastId}" class="toast align-items-center ${bgClass} border-0" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="d-flex">
                <div class="toast-body">
                    <i class="fas ${iconClass} me-2"></i>
                    ${message}
                </div>
                <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
        </div>
    `;

    // Add toast to container
    toastContainer.insertAdjacentHTML('beforeend', toastHtml);

    // Initialize and show the toast
    const toastElement = document.getElementById(toastId);
    const toast = new bootstrap.Toast(toastElement, {
        autohide: true,
        delay: 5000
    });
    
    toast.show();

    // Remove toast element after it's hidden
    toastElement.addEventListener('hidden.bs.toast', function() {
        this.remove();
    });
}

jQuery(document).ready(function($) {
    // Note: getPostIdFromBodyClass is now available globally from utilities.js

    // Listen for assignment updates to refresh the display
    document.addEventListener('assignmentsUpdated', function() {
        console.log('Assignment updated event received, refreshing display');
        loadProjectAssociationsDisplay();
    });

    // Function to update project safeguards
    function updateProjectSafeguards(evidenceId, project, safeguards) {
        console.log('Updating safeguards for project:', project, 'with:', safeguards);
        
        // Make sure safeguards is an array
        if (!Array.isArray(safeguards)) {
            safeguards = [];
        }
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'update_evidence_safeguards',
                evidence_id: evidenceId,
                project: project,
                safeguards: safeguards,
                nonce: evidenceData.nonce
            },
            success: function(response) {
                if (response.success) {
                    console.log('Safeguards updated successfully for project:', project);
                    loadProjectAssociationsDisplay(); // Refresh the display table
                } else {
                    console.error('Error updating safeguards:', response.data);
                    alert('Error updating safeguards. Please try again.');
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error:', {
                    status: status,
                    error: error,
                    response: xhr.responseText
                });
                alert('Error updating safeguards. Please try again.');
            }
        });
    }

    // Handle adding new project association
    $('#addProjectAssociation').on('click', function() {
        // Remove the empty state message if it exists
        $('.project-association-repeater .text-center').remove();
        
        // Clone the template and remove the project-selection-template class
        const $template = $('.project-selection-template').clone().removeClass('project-selection-template');
        
        // Add a unique identifier to this card for better isolation
        const cardId = 'project-card-' + new Date().getTime();
        $template.attr('data-card-id', cardId);
        $template.find('.safeguard-search-container').addClass('search-' + cardId);
        
        // Show the cloned template
        $template.show();
        
        // Initialize Select2 on the project selector
        $template.find('.project-selector').select2({
            placeholder: "Select an assessment",
            width: '100%',
            allowClear: false,
            minimumResultsForSearch: 0
        }).val(null).trigger('change');

        // Initialize Select2 on the safeguard selector and disable it initially
        const $safeguardSelector = $template.find('.safeguard-selector');
        $safeguardSelector.select2({
            placeholder: "Select safeguards",
            width: '100%',
            allowClear: false,
            minimumResultsForSearch: 0
        }).prop('disabled', true).val(null).trigger('change');

        // Add to repeater - insert after states and accordion but before other cards
        const $repeater = $('.project-association-repeater');
        const $existingCards = $repeater.find('.card:not(.template)');
        
        if ($existingCards.length > 0) {
            // Insert before the first existing card
            $existingCards.first().before($template);
        } else {
            // No existing cards, insert after accordion or states
            const $accordion = $repeater.find('.modal-accordion');
            if ($accordion.length > 0) {
                $accordion.after($template);
            } else {
                // No accordion, append after states
                $repeater.append($template);
            }
        }

        // Handle project selection change
        $template.find('.project-selector').on('change', function() {
            // Skip if we're loading existing associations
            if (window.isLoadingExistingAssociations) {
                console.log('Skipping project update during initial load');
                return;
            }
            
            const selectedProject = $(this).val();
            const evidenceId = getPostIdFromBodyClass();
            const $safeguardSelector = $(this).closest('.card').find('.safeguard-selector');
            
            if (selectedProject) {
                // Enable the safeguard selector and load the table
                const $tableContainer = $(this).closest('.card').find('.safeguard-table-container');
                const $searchContainer = $(this).closest('.card').find('.safeguard-search-container');
                
                // Clear any existing search inputs in this card's search container
                $searchContainer.find('input[type="search"]').remove();
                
                loadSafeguardsForProject(selectedProject, evidenceId, $tableContainer);
                
                // Get all currently selected projects
                const allProjects = [];
                $('.project-association-repeater .card:not(.template)').each(function() {
                    const projectVal = $(this).find('.project-selector').val();
                    if (projectVal) {
                        allProjects.push(projectVal);
                    }
                });
                
                console.log('Updating all projects:', allProjects);
                
                // Update DynamoDB with all projects
                $.ajax({
                    url: evidenceData.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'update_evidence_projects',
                        evidence_id: evidenceId,
                        projects: allProjects,
                        nonce: evidenceData.nonce
                    },
                    success: function(response) {
                        if (response.success) {
                            console.log('Projects updated successfully');
                        } else {
                            console.error('Error updating projects:', response.data);
                            alert('Error updating assessments. Please try again.');
                        }
                    },
                    error: function(xhr, status, error) {
                        console.error('AJAX error:', error);
                        alert('Error updating assessments. Please try again.');
                    }
                });
            } else {
                // Disable and clear the safeguard selector if no project is selected
                $safeguardSelector.prop('disabled', true).val(null).trigger('change');
                
                // Clear search inputs and clean up table in this card
                const $tableContainer = $(this).closest('.card').find('.safeguard-table-container');
                const $searchContainer = $(this).closest('.card').find('.safeguard-search-container');
                
                $searchContainer.find('input[type="search"]').remove();
                $tableContainer.find('table.safeguards-table-card').each(function() {
                    if ($.fn.DataTable.isDataTable(this)) {
                        $(this).DataTable().destroy();
                    }
                });
                $tableContainer.empty();
                
                // Get all currently selected projects (excluding this one)
                const remainingProjects = [];
                $('.project-association-repeater .card:not(.template)').each(function() {
                    if (this !== $(this).closest('.card')[0]) { // Skip the current card
                        const projectVal = $(this).find('.project-selector').val();
                        if (projectVal) {
                            remainingProjects.push(projectVal);
                        }
                    }
                });
                
                console.log('Remaining projects:', remainingProjects);
                
                // Update DynamoDB with remaining projects
                $.ajax({
                    url: evidenceData.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'update_evidence_projects',
                        evidence_id: evidenceId,
                        projects: remainingProjects,
                        nonce: evidenceData.nonce
                    },
                    success: function(response) {
                        if (response.success) {
                            console.log('Projects updated successfully after removal');
                        } else {
                            console.error('Error updating projects after removal:', response.data);
                            alert('Error updating assessments. Please try again.');
                        }
                    },
                    error: function(xhr, status, error) {
                        console.error('AJAX error:', error);
                        alert('Error updating assessments. Please try again.');
                    }
                });
            }
        });

        // Handle safeguard selection change
        $template.find('.safeguard-selector').on('change', function() {
            // Skip if we're loading existing associations
            if (window.isLoadingExistingAssociations) {
                console.log('Skipping safeguard update during initial load');
                return;
            }
            
            const selectedSafeguards = $(this).val();
            const project = $(this).closest('.card').find('.project-selector').val();
            const evidenceId = getPostIdFromBodyClass();
            
            if (project) {
                updateProjectSafeguards(evidenceId, project, selectedSafeguards);
            }
        });

        // Handle remove button click
        $template.find('.remove-project-selection').on('click', function() {
            const evidenceId = getPostIdFromBodyClass();
            const $card = $(this).closest('.card');
            
            // Clean up any DataTables and search inputs in this card
            $card.find('table.safeguards-table-card').each(function() {
                if ($.fn.DataTable.isDataTable(this)) {
                    $(this).DataTable().destroy();
                }
            });
            $card.find('.safeguard-search-container input[type="search"]').remove();
            
            // Remove the card from the DOM
            $card.remove();
            
            // Get all remaining projects
            const remainingProjects = [];
            $('.project-association-repeater .card:not(.template)').each(function() {
                const projectVal = $(this).find('.project-selector').val();
                if (projectVal) {
                    remainingProjects.push(projectVal);
                }
            });
            
            console.log('Remaining projects after removal:', remainingProjects);
            
            // Update DynamoDB with remaining projects
            $.ajax({
                url: evidenceData.ajax_url,
                type: 'POST',
                data: {
                    action: 'update_evidence_projects',
                    evidence_id: evidenceId,
                    projects: remainingProjects,
                    nonce: evidenceData.nonce
                },
                success: function(response) {
                    if (response.success) {
                        console.log('Projects updated successfully after removal');
                    } else {
                        console.error('Error updating projects after removal:', response.data);
                        alert('Error updating assessments. Please try again.');
                    }
                },
                error: function(xhr, status, error) {
                    console.error('AJAX error:', error);
                    alert('Error updating assessments. Please try again.');
                }
            });
        });
    });

    // Initialize Select2 on the project selector
    const $projectSelector = $('#projectSelector');
    const $safeguardSelector = $('#safeguardSelector');
    console.log('Project selector element found:', $projectSelector.length > 0);
    
    if ($projectSelector.length) {
        console.log('Initializing Select2 on project selector');
        console.log('Current options:', $projectSelector.find('option').length);
        
        $projectSelector.select2({
            placeholder: "Select assessments",
            width: '100%',
            allowClear: false,
            minimumResultsForSearch: 0
        }).on('select2:opening', function() {
            console.log('Select2 dropdown opening');
            console.log('Available options:', $(this).find('option').length);
        });

        // Load associated safeguards for previously selected projects on page load
        const selectedProjects = $projectSelector.val();
        if (selectedProjects && selectedProjects.length > 0) {
            const evidenceId = getPostIdFromBodyClass();
            if (evidenceId) {
                const $repeater = $('.associated-project-repeater');
                $repeater.empty();
                
                selectedProjects.forEach(project => {
                    const projectTitle = $projectSelector.find(`option[value="${project}"]`).text();
                    const $projectContainer = $(`
                        <div class="card mb-3">
                            <div class="card-header">
                                <h5 class="card-title mb-0">${projectTitle}</h5>
                            </div>
                            <div class="card-body">
                                <div class="project-safeguards">
                                    <label class="small mb-1">Associated Safeguards</label>
                                    <div class="associated-safeguard-repeater mb-2"></div>
                                    <select class="form-select safeguard-selector" data-project="${project}" multiple="multiple">
                                        <option value="">Loading safeguards...</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    `);
                    $repeater.append($projectContainer);
                    
                    // Initialize Select2 for this project's safeguard selector
                    const $safeguardSelector = $projectContainer.find('.safeguard-selector');
                    $safeguardSelector.select2({
                        placeholder: "Select safeguards",
                        width: '100%',
                        allowClear: false,
                        minimumResultsForSearch: 0
                    });

                    // Load safeguards for this project
                    loadSafeguardsForProject(project, evidenceId, $safeguardSelector.closest('.card').find('.safeguard-table-container'));
                });
            }
        }

        // Initialize Select2 on safeguard selector
        $safeguardSelector.select2({
            placeholder: "Select safeguards",
            width: '100%',
            allowClear: false,
            dropdownParent: $('.card-body'),
            minimumResultsForSearch: 0
        });

        // Handle project selection changes
        $projectSelector.on('change', function() {
            const selectedProjects = $(this).val();
            const evidenceId = getPostIdFromBodyClass();
            
            if (!evidenceId) {
                console.error('No evidence ID found');
                return;
            }

            // Update the associated projects display
            const $repeater = $('.associated-project-repeater');
            $repeater.empty();
            
            if (selectedProjects) {
                selectedProjects.forEach(project => {
                    // Get the project title from the select option
                    const projectTitle = $projectSelector.find(`option[value="${project}"]`).text();
                    const $projectContainer = $(`
                        <div class="card mb-3">
                            <div class="card-header">
                                <h5 class="card-title mb-0">${projectTitle}</h5>
                            </div>
                            <div class="card-body">
                                <div class="project-safeguards">
                                    <label class="small mb-1">Associated Safeguards</label>
                                    <div class="associated-safeguard-repeater mb-2"></div>
                                    <select class="form-select safeguard-selector" data-project="${project}" multiple="multiple">
                                        <option value="">Loading safeguards...</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    `);
                    $repeater.append($projectContainer);
                    
                    // Initialize Select2 for this project's safeguard selector
                    const $safeguardSelector = $projectContainer.find('.safeguard-selector');
                    $safeguardSelector.select2({
                        placeholder: "Select safeguards",
                        width: '100%',
                        allowClear: false,
                        minimumResultsForSearch: 0
                    });

                    // Load safeguards for this project
                    loadSafeguardsForProject(project, evidenceId, $safeguardSelector.closest('.card').find('.safeguard-table-container'));
                });
            }

            // Update DynamoDB
            $.ajax({
                url: evidenceData.ajax_url,
                type: 'POST',
                data: {
                    action: 'update_evidence_projects',
                    evidence_id: evidenceId,
                    projects: selectedProjects,
                    nonce: evidenceData.nonce
                },
                success: function(response) {
                    if (response.success) {
                        console.log('Projects updated successfully');
                    } else {
                        console.error('Error updating projects:', response.data);
                        alert('Error updating assessments. Please try again.');
                    }
                },
                error: function(xhr, status, error) {
                    console.error('AJAX error:', error);
                    alert('Error updating assessments. Please try again.');
                }
            });
        });

        // Handle safeguard selection changes for each project
        $(document).on('change', '.safeguard-selector', function() {
            const $selector = $(this);
            const project = $selector.data('project');
            const selectedSafeguards = $selector.val();
            const evidenceId = getPostIdFromBodyClass();
            
            if (!evidenceId || !project) {
                console.error('No evidence ID or project found');
                return;
            }

            // Update the associated safeguards display
            const $repeater = $selector.siblings('.associated-safeguard-repeater');
            $repeater.empty();
            
            if (selectedSafeguards) {
                selectedSafeguards.forEach(safeguard => {
                    $repeater.append(`<div class="associated-safeguard">${safeguard}</div>`);
                });
            }

            // Update DynamoDB
            $.ajax({
                url: evidenceData.ajax_url,
                type: 'POST',
                data: {
                    action: 'update_evidence_safeguards',
                    evidence_id: evidenceId,
                    project: project,
                    safeguards: selectedSafeguards,
                    nonce: evidenceData.nonce
                },
                success: function(response) {
                    console.log('Safeguards updated successfully');
                },
                error: function(xhr, status, error) {
                    console.error('AJAX error:', error);
                    alert('Error updating safeguards. Please try again.');
                }
            });
        });
    } else {
        console.log('Project selector not found in the DOM');
    }

    // Function to load and display project associations on the main page using new safeguard assignment system
    function loadProjectAssociationsDisplay() {
        console.log('loadProjectAssociationsDisplay: Function started');
        const evidencePostId = getPostIdFromBodyClass();
        if (!evidencePostId) {
            console.error('loadProjectAssociationsDisplay: Evidence post ID not found.');
            return;
        }
        console.log('loadProjectAssociationsDisplay: Evidence post ID found:', evidencePostId);

        const displayContainer = $('#project-associations-display');
        console.log('loadProjectAssociationsDisplay: Display container:', displayContainer);

        // Show loading state
        displayContainer.html(`
            <div class="text-center text-muted py-4">
                <i class="fas fa-spinner fa-spin fa-2x mb-2"></i>
                <p class="mb-0">Loading...</p>
            </div>
        `);

        // First, get the actual evidence ID (hash) from the post ID
        console.log('loadProjectAssociationsDisplay: Getting evidence ID hash for post ID:', evidencePostId);
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_evidence_id_from_post',
                post_id: evidencePostId,
                nonce: evidenceData.safeguard_assignment_nonce
            },
            success: function(response) {
                console.log('get_evidence_id_from_post response:', response);
                if (response.success && response.data) {
                    const evidenceId = response.data;
                    console.log('loadProjectAssociationsDisplay: Actual evidence ID (hash):', evidenceId);
                    loadSafeguardAssignments(evidenceId, displayContainer);
                } else {
                    console.error('loadProjectAssociationsDisplay: Failed to get evidence ID from post');
                    displayContainer.html(`
                        <div class="text-center text-danger py-4">
                            <i class="fas fa-exclamation-triangle fa-2x mb-2"></i>
                            <p class="mb-0">Error loading evidence information.</p>
                        </div>
                    `);
                }
            },
            error: function(xhr, status, error) {
                console.error('loadProjectAssociationsDisplay: Error getting evidence ID:', error);
                displayContainer.html(`
                    <div class="text-center text-danger py-4">
                        <i class="fas fa-exclamation-triangle fa-2x mb-2"></i>
                        <p class="mb-0">Error loading evidence information.</p>
                    </div>
                `);
            }
        });
    }
    
    // Clean up display assignments to remove old unassigned entries when newer assigned entries exist
    function cleanupDisplayAssignments(safeguardAssignments) {
        console.log('=== DISPLAY CLEANUP: Starting cleanup for safeguard assignments ===');
        console.log('Original assignments:', safeguardAssignments);
        
        const cleanedAssignments = [...safeguardAssignments];
        
        // Check if we have any assigned entries (assignedTo is not null/undefined and not 'unassigned')
        const assignedEntries = safeguardAssignments.filter(assignment => 
            assignment.assignedTo && 
            assignment.assignedTo !== null && 
            assignment.assignedTo !== undefined && 
            assignment.assignedToName !== 'Unassigned'
        );
        
        // Check if we have any unassigned entries
        const unassignedEntries = safeguardAssignments.filter(assignment => 
            !assignment.assignedTo || 
            assignment.assignedTo === null || 
            assignment.assignedTo === undefined || 
            assignment.assignedToName === 'Unassigned'
        );
        
        console.log(`DISPLAY CLEANUP: Found ${assignedEntries.length} assigned entries and ${unassignedEntries.length} unassigned entries`);
        
        // If we have both assigned and unassigned entries, remove older unassigned entries
        if (assignedEntries.length > 0 && unassignedEntries.length > 0) {
            console.log('DISPLAY CLEANUP: Found both assigned and unassigned entries, checking timestamps');
            
            // Find the newest assigned entry
            const newestAssignedEntry = assignedEntries.reduce((newest, current) => {
                const currentTime = new Date(current.assignedDate).getTime();
                const newestTime = new Date(newest.assignedDate).getTime();
                return currentTime > newestTime ? current : newest;
            });
            
            console.log('DISPLAY CLEANUP: Newest assigned entry:', newestAssignedEntry);
            
            // Remove unassigned entries that are older than the newest assigned entry
            unassignedEntries.forEach(unassignedEntry => {
                const unassignedTime = new Date(unassignedEntry.assignedDate).getTime();
                const newestTime = new Date(newestAssignedEntry.assignedDate).getTime();
                
                console.log(`DISPLAY CLEANUP: Comparing unassigned (${unassignedEntry.assignedDate}) vs newest assigned (${newestAssignedEntry.assignedDate})`);
                
                if (unassignedTime < newestTime) {
                    console.log('DISPLAY CLEANUP: Removing older unassigned entry:', unassignedEntry);
                    
                    // Remove the unassigned entry from cleaned assignments
                    const index = cleanedAssignments.findIndex(assignment => 
                        assignment.assignmentID === unassignedEntry.assignmentID
                    );
                    
                    if (index !== -1) {
                        cleanedAssignments.splice(index, 1);
                        console.log(`DISPLAY CLEANUP: Removed unassigned entry at index ${index}`);
                    }
                } else {
                    console.log('DISPLAY CLEANUP: Keeping unassigned entry (newer or same age)');
                }
            });
        }
        
        // console.log('=== DISPLAY CLEANUP: Final cleaned assignments ===');
        // console.log('Original count:', safeguardAssignments.length);
        // console.log('Cleaned count:', cleanedAssignments.length);
        // console.log('Cleaned assignments:', cleanedAssignments);
        
        return cleanedAssignments;
    }

    function createAccordionWithProjectNames(assignmentsByProject, projectDetails, displayContainer) {
        console.log('createAccordionWithProjectNames: Creating accordion with project details:', projectDetails);
        
        // Create accordion structure
        const accordion = $(`
            <div class="accordion" id="projectAssociationsAccordion">
            </div>
        `);

        let accordionIndex = 0;
        for (const projectId in assignmentsByProject) {
            const projectAssignments = assignmentsByProject[projectId];
            const accordionId = `project-${accordionIndex}`;
            
            // Get project name from fetched details or use ID as fallback
            const projectName = projectDetails[projectId] ? projectDetails[projectId].name : projectId;
            console.log(`Project ${projectId} name:`, projectName);
            
            // Create accordion item
            const accordionItem = $(`
                <div class="accordion-item">
                    <h2 class="accordion-header" id="heading-${accordionId}">
                        <button class="accordion-button collapsed" type="button" 
                                data-bs-toggle="collapse" data-bs-target="#collapse-${accordionId}" 
                                aria-expanded="false" aria-controls="collapse-${accordionId}">
                            ${projectName}
                        </button>
                    </h2>
                    <div id="collapse-${accordionId}" class="accordion-collapse collapse" 
                         aria-labelledby="heading-${accordionId}" data-bs-parent="#projectAssociationsAccordion">
                        <div class="accordion-body">
                            <div class="safeguards-table-container m-4"></div>
                        </div>
                    </div>
                </div>
            `);
            
            const safeguardsContainer = accordionItem.find('.safeguards-table-container');
            
            // Create table for this project's safeguard assignments
            const hasEditPermissions = typeof evidencePermissions !== 'undefined' && evidencePermissions.can_edit;
            const actionsColumn = hasEditPermissions ? '<th class="safeguard-actions" style="width: 5%; text-align: center;">Actions</th>' : '';
            const actionsColumnWidth = hasEditPermissions ? '5%' : '0%';
            
            const safeguardsTable = $(`
                <table class="datatable-table table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th class="safeguard-id" style="width: 12%;">Safeguard ID</th>
                            <th class="safeguard-description" style="width: 28%;">Description</th>
                            <th class="safeguard-assigned-to" style="width: 20%;">Assigned To</th>
                            <th class="safeguard-assigned-by" style="width: 20%;">Assigned By</th>
                            <th class="safeguard-date" style="width: ${hasEditPermissions ? '15%' : '20%'};">Assignment Date</th>
                            ${actionsColumn}
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            `);
            const safeguardsTbody = safeguardsTable.find('tbody');
            
            // Group assignments by safeguard ID
            const assignmentsBySafeguard = {};
            projectAssignments.forEach(assignment => {
                const safeguardId = assignment.safeguardID === null || assignment.safeguardID === undefined
                    ? ''
                    : String(assignment.safeguardID).trim();

                if (!safeguardId || safeguardId.toLowerCase() === 'undefined' || safeguardId.toLowerCase() === 'null') {
                    console.warn('Skipping safeguard assignment with missing safeguardID:', assignment);
                    return;
                }

                if (!assignmentsBySafeguard[safeguardId]) {
                    assignmentsBySafeguard[safeguardId] = [];
                }
                assignmentsBySafeguard[safeguardId].push(Object.assign({}, assignment, {
                    safeguardID: safeguardId
                }));
            });
            
            // Filter out PROJECT_ASSOCIATION_ONLY entries and create rows for each safeguard
            const validSafeguards = [];
            for (const safeguardId in assignmentsBySafeguard) {
                // Skip PROJECT_ASSOCIATION_ONLY entries
                if (safeguardId === 'PROJECT_ASSOCIATION_ONLY') {
                    continue;
                }
                
                const safeguardAssignments = assignmentsBySafeguard[safeguardId];
                
                // Clean up old unassigned entries when newer assigned entries exist
                const cleanedAssignments = cleanupDisplayAssignments(safeguardAssignments);
                
                // Filter out assignments with invalid assignment IDs (API Gateway path parameter issues)
                const validAssignments = cleanedAssignments.filter(assignment => {
                    // Check if assignmentID is a valid UUID format (not {assignmentID} or similar)
                    const isValidId = assignment.assignmentID && 
                                    assignment.assignmentID !== '{assignmentID}' && 
                                    assignment.assignmentID !== '%7BassignmentID%7D' &&
                                    assignment.assignmentID.length > 10; // UUIDs are longer than 10 characters
                    
                    if (!isValidId) {
                        console.log('FILTERING OUT INVALID ASSIGNMENT ID:', assignment.assignmentID);
                    }
                    
                    return isValidId;
                });
                
                console.log('FILTERED ASSIGNMENTS - Original count:', cleanedAssignments.length, 'Valid count:', validAssignments.length);
                
                // Deduplicate assignments: keep only the most recent for each unique safeguard ID + assigned user combination
                const uniqueAssignments = new Map();
                validAssignments.forEach(assignment => {
                    // Handle unassigned safeguards (assignedTo is null/undefined)
                    const assignedToValue = assignment.assignedTo || 'unassigned';
                    const key = `${safeguardId}-${assignedToValue}`;
                    const existingAssignment = uniqueAssignments.get(key);
                    
                    if (!existingAssignment || new Date(assignment.assignedDate) > new Date(existingAssignment.assignedDate)) {
                        uniqueAssignments.set(key, assignment);
                    }
                });
                
                // Add valid safeguards to the list
                validSafeguards.push({ safeguardId, uniqueAssignments });
            }
                
            // Function to format date with time for debugging
            function formatDate(dateString) {
                if (!dateString || dateString === 'Unknown Date') {
                    return 'Unknown Date';
                }
                const date = new Date(dateString);
                if (isNaN(date.getTime())) {
                    return 'Invalid Date';
                }
                return date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                }) + ' ' + date.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                }) + ' (ET)';
            }
            
            // Check if we have any valid safeguards
            if (validSafeguards.length === 0) {
                // Show just the text message without table
                const emptyMessage = $(`
                    <div class="text-center text-muted py-4">
                        <em>No safeguards have been assigned to this assessment</em>
                    </div>
                `);
                safeguardsContainer.append(emptyMessage);
            } else {
                // Sort safeguards by ID (handle numeric sorting for IDs like 1.1, 1.2, 12.3, etc.)
                validSafeguards.sort((a, b) => {
                    const aId = a.safeguardId;
                    const bId = b.safeguardId;
                    
                    // Split by decimal point for proper numeric sorting
                    const aParts = aId.split('.').map(part => parseInt(part, 10));
                    const bParts = bId.split('.').map(part => parseInt(part, 10));
                    
                    // Compare major version first, then minor version
                    for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
                        const aPart = aParts[i] || 0;
                        const bPart = bParts[i] || 0;
                        
                        if (aPart !== bPart) {
                            return aPart - bPart;
                        }
                    }
                    
                    return 0;
                });
                
                // Create rows for each valid safeguard
                validSafeguards.forEach(({ safeguardId, uniqueAssignments }) => {
                    // Create a row for each unique assignment (most recent only)
                    uniqueAssignments.forEach(assignment => {
                        // Handle unassigned safeguards
                        const assignedToDisplay = assignment.assignedTo ? (assignment.assignedToName || 'Unknown User') : 'Unassigned';
                        const assignedToValue = assignment.assignedTo || 'unassigned';
                        
                        const actionsCell = hasEditPermissions ? 
                            `<td class="safeguard-actions text-center">
                                <button class="btn btn-sm remove-safeguard-assignment safeguard-delete" 
                                        data-project-id="${assignment.projectID}" 
                                        data-safeguard-id="${safeguardId}"
                                        data-evidence-id="${assignment.evidenceID}"
                                        data-assigned-to="${assignedToValue}"
                                        title="Remove this assignment">
                                </button>
                            </td>` : '';
                        
                        const row = $(`
                            <tr>
                                <td class="safeguard-id">${safeguardId}</td>
                                <td class="safeguard-description">${assignment.safeguardDescription || 'N/A'}</td>
                                <td class="safeguard-assigned-to">${assignedToDisplay}</td>
                                <td class="safeguard-assigned-by">${assignment.assignedByName || 'Unknown User'}</td>
                                <td class="safeguard-date">${formatDate(assignment.assignedDate)}</td>
                                ${actionsCell}
                            </tr>
                        `);
                        safeguardsTbody.append(row);
                    });
                });
            }
            
                            // Add edit button - either in table or standalone based on whether we have safeguards
                            // Only show edit buttons if user has edit permissions
                            if (typeof evidencePermissions !== 'undefined' && evidencePermissions.can_edit) {
                                if (validSafeguards.length === 0) {
                                    // Add button after the empty message
                                    const addButton = $(`
                                        <div class="text-center py-3">
                                            <button type="button" class="btn btn-primary edit-project-assignments-btn" 
                                                    data-project-id="${projectId}"
                                                    data-project-name="${projectName}"
                                                    title="Add safeguard assignments for this assessment">
                                                <i class="fas fa-plus"></i> Add Assignments
                                            </button>
                                            <br>
                                            <a href="#" class="remove-project-association-link text-danger mt-2" 
                                               data-project-id="${projectId}" 
                                               data-project-name="${projectName}"
                                               title="Remove this assessment association">
                                                Remove
                                            </a>
                                        </div>
                                    `);
                                    safeguardsContainer.append(addButton);
                                } else {
                                    // Add edit button as a table row
                                    const colspan = hasEditPermissions ? '6' : '5';
                                    const editAssignmentsRow = $(`
                                        <tr class="edit-assignments-row">
                                            <td colspan="${colspan}" class="text-center">
                                                <button type="button" class="btn btn-primary edit-project-assignments-btn" 
                                                        data-project-id="${projectId}"
                                                        data-project-name="${projectName}"
                                                        title="Edit safeguard assignments for this assessment">
                                                    <i class="fas fa-edit"></i> Edit Assignments
                                                </button>
                                            </td>
                                        </tr>
                                    `);
                                    safeguardsTbody.append(editAssignmentsRow);
                                }
                            }
                            
                            // Always append the table if we have safeguards, regardless of edit permissions
                            if (validSafeguards.length > 0) {
                                safeguardsContainer.append(safeguardsTable);
                            }
            accordion.append(accordionItem);
            accordionIndex++;
        }
        
        // Clear loading state and show accordion
        displayContainer.empty();
        displayContainer.append(accordion);
        
        // Add event handlers for assignment buttons
        accordion.on('click', '.safeguard-assignment-btn', function() {
            const $button = $(this);
            const controlId = $button.data('control-id');
            const projectId = $button.data('project-id');
            
            console.log('Safeguard assignment clicked for control ID:', controlId, 'in project:', projectId);
            
            if (typeof window.safeguardAssignment !== 'undefined') {
                window.safeguardAssignment.currentControlId = controlId;
                window.safeguardAssignment.currentProjectId = projectId;
                window.safeguardAssignment.showModal();
                window.safeguardAssignment.loadEvidencePosts();
                window.safeguardAssignment.loadCorporateUsers();
                window.safeguardAssignment.loadExistingAssignments();
            } else {
                console.error('Safeguard assignment module not available');
            }
        });
        
        // Add event handlers for view assignments buttons
        accordion.on('click', '.view-assignments-btn', function() {
            const $button = $(this);
            const controlId = $button.data('control-id');
            const projectId = $button.data('project-id');
            
            console.log('View assignments clicked for control ID:', controlId, 'in project:', projectId);
            
            if (typeof window.safeguardAssignment !== 'undefined') {
                window.safeguardAssignment.currentControlId = controlId;
                window.safeguardAssignment.currentProjectId = projectId;
                window.safeguardAssignment.showModal();
                window.safeguardAssignment.loadExistingAssignments();
            } else {
                console.error('Safeguard assignment module not available');
            }
        });
        
        // Add event handlers for remove assignment buttons
        accordion.on('click', '.remove-safeguard-assignment', function() {
            console.log('=== DELETE BUTTON CLICKED ===');
            const $button = $(this);
            const projectId = $button.data('project-id');
            const safeguardId = $button.data('safeguard-id');
            const evidenceId = $button.data('evidence-id');
            const assignedTo = $button.data('assigned-to');
            
            console.log('Delete button data:', {
                projectId: projectId,
                safeguardId: safeguardId,
                evidenceId: evidenceId,
                assignedTo: assignedTo
            });
            
            if (confirm('Are you sure you want to remove this assignment?')) {
                console.log('User confirmed deletion');
                if (typeof window.safeguardAssignment !== 'undefined') {
                    console.log('Calling removeAssignment...');
                    window.safeguardAssignment.removeAssignment(projectId, safeguardId, evidenceId, assignedTo);
                } else {
                    console.error('Safeguard assignment module not available');
                }
            } else {
                console.log('User cancelled deletion');
            }
        });
        
        // Add event handler for remove project association link
        accordion.on('click', '.remove-project-association-link', function(e) {
            e.preventDefault();
            const $link = $(this);
            const projectId = $link.data('project-id');
            const projectName = $link.data('project-name');
            
            console.log('Remove project association clicked for project:', projectId, projectName);
            
            if (confirm(`Are you sure you want to remove the association with assessment "${projectName}"?`)) {
                // Get evidence ID from current context
                const evidenceId = getPostIdFromBodyClass();
                
                if (!evidenceId) {
                    console.error('No evidence ID found');
                    alert('Error: No evidence ID found. Please refresh the page and try again.');
                    return;
                }
                
                // First, get the actual evidence slug from the post ID
                $.ajax({
                    url: evidenceData.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'safeguard_assignment',
                        subaction: 'get_evidence_id_from_post',
                        post_id: evidenceId,
                        nonce: evidenceData.safeguard_assignment_nonce
                    },
                    success: function(response) {
                        if (response.success && response.data) {
                            const evidenceSlug = response.data;
                            console.log('Remove project association: Evidence slug:', evidenceSlug);
                            
                            // Get current assignments to find PROJECT_ASSOCIATION_ONLY entries
                            $.ajax({
                                url: evidenceData.ajax_url,
                                type: 'POST',
                                data: {
                                    action: 'safeguard_assignment',
                                    subaction: 'get_evidence_assignments',
                                    evidence_id: evidenceSlug,
                                    nonce: evidenceData.safeguard_assignment_nonce
                                },
                                success: function(assignmentsResponse) {
                                    if (assignmentsResponse.success && assignmentsResponse.data) {
                                        // Find PROJECT_ASSOCIATION_ONLY assignments for this project
                                        const projectAssociationAssignments = assignmentsResponse.data.filter(assignment => 
                                            assignment.projectID === projectId && 
                                            assignment.safeguardID === 'PROJECT_ASSOCIATION_ONLY'
                                        );
                                        
                                        console.log('Found PROJECT_ASSOCIATION_ONLY assignments:', projectAssociationAssignments);
                                        
                                        if (projectAssociationAssignments.length > 0) {
                                            // Remove each PROJECT_ASSOCIATION_ONLY assignment
                                            let completedRemovals = 0;
                                            let failedRemovals = 0;
                                            
                                            projectAssociationAssignments.forEach(assignment => {
                                                // Use the existing removeAssignment function from safeguardAssignment module
                                                if (typeof window.safeguardAssignment !== 'undefined') {
                                                    window.safeguardAssignment.removeAssignment(
                                                        assignment.projectID,
                                                        assignment.safeguardID,
                                                        assignment.evidenceID,
                                                        'unassigned' // Use 'unassigned' since assignedTo is null
                                                    );
                                                    completedRemovals++;
                                                } else {
                                                    console.error('Safeguard assignment module not available');
                                                    failedRemovals++;
                                                }
                                            });
                                            
                                            if (completedRemovals > 0) {
                                                console.log('Project association removed successfully');
                                                // Refresh the display
                                                if (typeof window.loadProjectAssociationsDisplay === 'function') {
                                                    window.loadProjectAssociationsDisplay();
                                                }
                                            } else {
                                                alert('Error removing assessment association. Please try again.');
                                            }
                                        } else {
                                            console.log('No PROJECT_ASSOCIATION_ONLY assignments found for this project');
                                            // Fallback: use the update_evidence_safeguards method
                                            $.ajax({
                                                url: evidenceData.ajax_url,
                                                type: 'POST',
                                                data: {
                                                    action: 'update_evidence_safeguards',
                                                    evidence_id: evidenceSlug,
                                                    project: projectId,
                                                    safeguards: [], // Empty array removes all safeguards for this project
                                                    nonce: evidenceData.nonce
                                                },
                                                success: function(response) {
                                                    if (response.success) {
                                                        console.log('Project association removed successfully via fallback method');
                                                        // Refresh the display
                                                        if (typeof window.loadProjectAssociationsDisplay === 'function') {
                                                            window.loadProjectAssociationsDisplay();
                                                        }
                                                    } else {
                                                        console.error('Error removing project association via fallback:', response.data);
                                                        alert('Error removing assessment association. Please try again.');
                                                    }
                                                },
                                                error: function(xhr, status, error) {
                                                    console.error('AJAX error removing project association via fallback:', error);
                                                    alert('Error removing assessment association. Please try again.');
                                                }
                                            });
                                        }
                                    } else {
                                        console.error('Failed to get current assignments');
                                        alert('Error getting current assignments. Please try again.');
                                    }
                                },
                                error: function(xhr, status, error) {
                                    console.error('AJAX error getting current assignments:', error);
                                    alert('Error getting current assignments. Please try again.');
                                }
                            });
                        } else {
                            console.error('Failed to get evidence slug from post ID');
                            alert('Error getting evidence information. Please try again.');
                        }
                    },
                    error: function(xhr, status, error) {
                        console.error('Error getting evidence slug:', error);
                        alert('Error getting evidence information. Please try again.');
                    }
                });
            }
        });
        
        // Add event handler for edit assignments button
        accordion.on('click', '.edit-project-assignments-btn', function() {
            const $button = $(this);
            const projectId = $button.data('project-id');
            const projectName = $button.data('project-name');
            
            console.log('Edit assignments clicked for project:', projectId, projectName);
            
            // Get evidence post ID from current context
            const evidencePostId = getPostIdFromBodyClass();
            
            // Set up modal for editing this project's assignments
            modalIsEditMode = true;
            modalSelectedProject = projectId;
            modalSelectedProjectName = projectName;
            
            // Update modal title for editing
            $('#projectAssociationsModalLabel').text('Edit Assessment Assignments');
            
            // Skip step 1 and go directly to step 2
            modalCurrentStep = 2;
            $('#step1-project-selection').hide();
            $('#step2-safeguard-selection').show();
            $('#step1-buttons').hide();
            $('#step2-buttons').show();
            
            // Hide the back button in edit mode since there's no step 1 to go back to
            $('#backToStep1').hide();
            
            // Update project name display
            $('#selectedProjectName').text(modalSelectedProjectName);
            
            // Show loading animation immediately before opening modal
            const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
            $tableContainer.find('.safeguard-loading').removeClass('d-none');
            $tableContainer.find('table, .alert').addClass('d-none');
            
            // Show the modal
            $('#projectAssociationsModal').modal('show');
            
            // First, get the actual evidence ID (hash) from the post ID
            console.log('Edit assignments: Getting evidence ID hash for post ID:', evidencePostId);
            
            $.ajax({
                url: evidenceData.ajax_url,
                type: 'POST',
                data: {
                    action: 'safeguard_assignment',
                    subaction: 'get_evidence_id_from_post',
                    post_id: evidencePostId,
                    nonce: evidenceData.safeguard_assignment_nonce
                },
                success: function(response) {
                    console.log('get_evidence_id_from_post response:', response);
                    if (response.success && response.data) {
                        const evidenceId = response.data;
                        console.log('Edit assignments: Actual evidence ID (hash):', evidenceId);
                        
                        // Load safeguards for this project with existing selections pre-populated
                        const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
                        const $searchContainer = $('#step2-safeguard-selection .safeguard-search-container');
                        
                        // Show loading animation
                        $tableContainer.find('.safeguard-loading').removeClass('d-none');
                        $tableContainer.find('table, .alert').addClass('d-none');
                        
                        // Load safeguards for this project
                        if (typeof window.loadSafeguardsForModal === 'function') {
                            window.loadSafeguardsForModal(projectId, evidenceId, $tableContainer, $searchContainer);
                        } else {
                            console.error('loadSafeguardsForModal function not available');
                        }
                    } else {
                        console.error('Edit assignments: Failed to get evidence ID from post');
                        // Show error in modal
                        const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
                        $tableContainer.find('.safeguard-loading').addClass('d-none');
                        $tableContainer.html(`
                            <div class="alert alert-danger">
                                <strong>Error:</strong> Failed to load evidence information.
                            </div>
                        `);
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Edit assignments: Error getting evidence ID:', error);
                    // Show error in modal
                    const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
                    $tableContainer.find('.safeguard-loading').addClass('d-none');
                    $tableContainer.html(`
                        <div class="alert alert-danger">
                            <strong>Error:</strong> Failed to load evidence information.
                        </div>
                    `);
                }
            });
        });
    }
    
    function loadSafeguardAssignments(evidenceId, displayContainer) {
        console.log('loadSafeguardAssignments: Loading assignments for evidence ID:', evidenceId);
        
        // Get all safeguard assignments for this evidence using the new API
        console.log('loadSafeguardAssignments: Sending AJAX request with data:', {
            action: 'safeguard_assignment',
            subaction: 'get_evidence_assignments',
            evidence_id: evidenceId,
            nonce: evidenceData.safeguard_assignment_nonce
        });
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_evidence_assignments',
                evidence_id: evidenceId,
                nonce: evidenceData.safeguard_assignment_nonce
            },
            success: function(response) {
                console.log('loadProjectAssociationsDisplay: AJAX success. Full response:', response);
                console.log('loadProjectAssociationsDisplay: Response success:', response.success);
                console.log('loadProjectAssociationsDisplay: Response data:', response.data);
                console.log('loadProjectAssociationsDisplay: Response data type:', typeof response.data);
                console.log('loadProjectAssociationsDisplay: Response data length:', response.data ? response.data.length : 'N/A');
                
                if (response.success && response.data) {
                    const assignments = response.data;
                    console.log('loadProjectAssociationsDisplay: Assignments data:', assignments);
                    console.log('loadProjectAssociationsDisplay: Assignments array length:', assignments.length);
                    
                    // Keep loading state until accordion is ready
                    // displayContainer.empty(); // Don't clear yet

                    if (assignments.length > 0) {
                        // Group assignments by project
                        const assignmentsByProject = {};
                        assignments.forEach(assignment => {
                            if (!assignmentsByProject[assignment.projectID]) {
                                assignmentsByProject[assignment.projectID] = [];
                            }
                            assignmentsByProject[assignment.projectID].push(assignment);
                        });

                        // Get unique project IDs
                        const projectIds = Object.keys(assignmentsByProject);
                        console.log('loadSafeguardAssignments: Project IDs to fetch:', projectIds);

                        // Fetch project details to get names
                        $.ajax({
                            url: evidenceData.ajax_url,
                            type: 'POST',
                            data: {
                                action: 'safeguard_assignment',
                                subaction: 'get_project_details',
                                project_ids: projectIds,
                                nonce: evidenceData.safeguard_assignment_nonce
                            },
                            success: function(projectResponse) {
                                console.log('get_project_details response:', projectResponse);
                                
                                if (projectResponse.success && projectResponse.data) {
                                    const projectDetails = projectResponse.data;
                                    console.log('Project details:', projectDetails);
                                    createAccordionWithProjectNames(assignmentsByProject, projectDetails, displayContainer);
                                } else {
                                    console.error('Failed to get project details, using fallback');
                                    createAccordionWithProjectNames(assignmentsByProject, {}, displayContainer);
                                }
                            },
                            error: function(xhr, status, error) {
                                console.error('get_project_details error:', error);
                                console.log('Falling back to using project IDs as names');
                                createAccordionWithProjectNames(assignmentsByProject, {}, displayContainer);
                            }
                        });
                        
                    } else {
                        // No assignments found
                        displayContainer.html(`
                            <div class="text-center text-muted py-4">
                                <i class="fas fa-info-circle fa-2x mb-2"></i>
                                <p class="mb-0">No safeguard assignments found for this evidence.</p>
                                <p class="small">Use the "Add Associations" button above to create new assignments.</p>
                            </div>
                        `);
                    }
                } else {
                    console.error('loadProjectAssociationsDisplay: AJAX call was not successful. Response:', response);
                    displayContainer.html(`
                        <div class="text-center text-danger py-4">
                            <i class="fas fa-exclamation-triangle fa-2x mb-2"></i>
                            <p class="mb-0">Error loading safeguard assignments.</p>
                        </div>
                    `);
                }
            },
            error: function(xhr, status, error) {
                console.error('loadProjectAssociationsDisplay: AJAX error details:', { 
                    status: status, 
                    error: error, 
                    xhr: xhr,
                    responseText: xhr.responseText,
                    statusCode: xhr.status
                });
                console.error('loadProjectAssociationsDisplay: Full error object:', xhr);
                displayContainer.html(`
                    <div class="text-center text-danger py-4">
                        <i class="fas fa-exclamation-triangle fa-2x mb-2"></i>
                        <p class="mb-0">Error loading safeguard assignments.</p>
                    </div>
                `);
            }
        });
    }

    // Function to load existing project associations
    function loadExistingProjectAssociations() {
        const evidenceId = getPostIdFromBodyClass();
        if (!evidenceId) return;

        // Show loading state, hide empty state
        $('.project-association-repeater .loading-state').show();
        $('.project-association-repeater .empty-state').hide();
        
        // Clear any existing project associations first
        // Destroy any existing DataTables first to prevent conflicts
        $('.project-association-repeater table.safeguards-table-card, .project-association-repeater table.safeguards-table-accordion').each(function() {
            if ($.fn.DataTable.isDataTable(this)) {
                $(this).DataTable().destroy();
            }
        });
        $('.project-association-repeater .card:not(.template)').remove();
        $('.project-association-repeater .modal-accordion').remove();

        // Flag to prevent triggering change events during initial load
        window.isLoadingExistingAssociations = true;

        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'get_evidence_projects_with_safeguards',
                evidence_id: evidenceId,
                nonce: evidenceData.nonce
            },
            success: function(response) {
                console.log('Modal projects response:', response);
                if (response.success && response.data && Object.keys(response.data).length > 0) {
                    const associations = response.data;
                    console.log('Loading modal project associations:', associations);
                    
                    // Create accordion for existing projects
                    const modalAccordion = $(`
                        <div class="accordion modal-accordion" id="modalProjectAssociationsAccordion">
                        </div>
                    `);
                    
                    // Get project details first
                    const projectSlugs = Object.keys(associations);
                    
                    $.ajax({
                        url: evidenceData.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'get_project_safeguard_details',
                            project_slugs: projectSlugs,
                            associations: associations,
                            nonce: evidenceData.nonce
                        },
                        success: function(detailsResponse) {
                            if (detailsResponse.success && detailsResponse.data) {
                                const details = detailsResponse.data;
                                
                                // Create accordion items for existing projects
                                let accordionIndex = 0;
                                for (const projectSlug in associations) {
                                    if (associations.hasOwnProperty(projectSlug)) {
                                        const projectData = details.projects[projectSlug];
                                        const projectName = projectData ? projectData.name : projectSlug;
                                        const accordionId = `modal-project-${accordionIndex}`;
                                        
                                        // Create accordion item
                                        const accordionItem = $(`
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="modal-heading-${accordionId}">
                                                    <div class="d-flex align-items-center">
                                                        <button class="accordion-button collapsed flex-grow-1" type="button" 
                                                                data-bs-toggle="collapse" data-bs-target="#modal-collapse-${accordionId}" 
                                                                aria-expanded="false" aria-controls="modal-collapse-${accordionId}">
                                                            ${projectName}
                                                        </button>
                                                        <button type="button" class="btn btn-sm remove-existing-project me-2" 
                                                                data-project-slug="${projectSlug}" 
                                                                title="Remove this assessment association">
                                                            Remove
                                                        </button>
                                                    </div>
                                                </h2>
                                                <div id="modal-collapse-${accordionId}" class="accordion-collapse collapse" 
                                                     aria-labelledby="modal-heading-${accordionId}" data-bs-parent="#modalProjectAssociationsAccordion">
                                                    <div class="accordion-body">
                                                        <div class="safeguard-search-container safeguard-search-${accordionId} mb-3">
                                                            <label class="small mb-1">Search Safeguards</label>
                                                        </div>
                                                        <div class="safeguard-table-container"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        `);
                                        
                                        modalAccordion.append(accordionItem);
                                        
                                        // Load safeguards for this project
                                        const $tableContainer = accordionItem.find('.safeguard-table-container');
                                        loadSafeguardsForProjectSilently(projectSlug, evidenceId, $tableContainer);
                                        
                                        accordionIndex++;
                                    }
                                }
                                
                                // Insert accordion before the empty state and after loading state
                                $('.project-association-repeater .loading-state').after(modalAccordion);
                                
                                // Add click handler for remove project buttons
                                modalAccordion.on('click', '.remove-existing-project', function(e) {
                                    e.stopPropagation(); // Prevent accordion toggle
                                    const projectSlug = $(this).data('project-slug');
                                    const $accordionItem = $(this).closest('.accordion-item');
                                    
                                    if (confirm('Are you sure you want to remove all associations for this assessment?')) {
                                        // Remove the accordion item
                                        $accordionItem.fadeOut(300, function() {
                                            $(this).remove();
                                            
                                            // Check if accordion is now empty
                                            if (modalAccordion.find('.accordion-item').length === 0) {
                                                modalAccordion.remove();
                                                $('.project-association-repeater .empty-state').show();
                                            }
                                        });
                                        
                                        // Update the associations data in the backend by removing this project
                                        $.ajax({
                                            url: evidenceData.ajax_url,
                                            type: 'POST',
                                            data: {
                                                action: 'update_evidence_safeguards',
                                                evidence_id: evidenceId,
                                                project: projectSlug,
                                                safeguards: [], // Empty array removes all safeguards for this project
                                                nonce: evidenceData.nonce
                                            },
                                            success: function(response) {
                                                if (response.success) {
                                                    console.log('Project association removed successfully');
                                                    // Also refresh the main display
                                                    loadProjectAssociationsDisplay();
                                                } else {
                                                    console.error('Error removing project association:', response.data);
                                                }
                                            },
                                            error: function(xhr, status, error) {
                                                console.error('AJAX error removing project association:', error);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    });
                    
                    // Hide loading state
                    $('.project-association-repeater .loading-state').hide();
                    
                    // Reset the flag after a delay
                    setTimeout(function() {
                        window.isLoadingExistingAssociations = false;
                    }, 1000);
                } else {
                    // Show empty state if no projects
                    $('.project-association-repeater .loading-state').hide();
                    $('.project-association-repeater .empty-state').show();
                    window.isLoadingExistingAssociations = false;
                }
            },
            error: function(xhr, status, error) {
                console.error('Error loading project associations:', error);
                // Show empty state on error
                $('.project-association-repeater .loading-state').hide();
                $('.project-association-repeater .empty-state').show();
                window.isLoadingExistingAssociations = false;
            }
        });
    }

    // Initial load of the display area
    loadProjectAssociationsDisplay();

    // New modal workflow variables
    let modalCurrentStep = 1;
    let modalSelectedProject = null;
    let modalSelectedProjectName = null;
    let modalIsEditMode = false;
    
    // Global tracking for modal safeguard selections and user assignments
    // These track selections across all DataTable pages
    window.modalSafeguardSelections = []; // Array of selected safeguard IDs
    window.modalUserAssignments = {}; // Object mapping safeguardId to array of user IDs

    // Handle opening of project associations modal
    $('#projectAssociationsModal').on('show.bs.modal', function () {
        console.log('=== PROJECT ASSOCIATIONS MODAL OPENING ===');
        console.log('Edit mode:', modalIsEditMode);
        // console.log('🔍 MODAL OPEN - Global selections before reset:', window.modalSafeguardSelections);
        // console.log('🔍 MODAL OPEN - Global user assignments before reset:', window.modalUserAssignments);
        
        // Debug: Check dropdown state when modal opens
        const $modalSelector = $('#modalProjectSelector');
        console.log('Dropdown options count on modal open:', $modalSelector.find('option').length);
        console.log('First few options:', $modalSelector.find('option').slice(0, 5).map(function() {
            return { value: this.value, text: this.text };
        }).get());
        
        // Only reset modal if we're not in edit mode
        // Edit mode is set up before the modal is shown
        if (!modalIsEditMode) {
            console.log('Not in edit mode, resetting modal...');
            resetModal();
        } else {
            console.log('In edit mode, skipping modal reset');
        }
    });

    // Handle closing of project associations modal
    $('#projectAssociationsModal').on('hidden.bs.modal', function () {
        console.log('Project associations modal is closing.');
        
        // Always reset edit mode when modal is closed
        modalIsEditMode = false;
        
        // Clean up any DataTables when modal closes
        const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
        $tableContainer.find('table').each(function() {
            if ($.fn.DataTable.isDataTable(this)) {
                $(this).DataTable().destroy();
            }
        });
        // Remove dynamic content but preserve loading animation
        $tableContainer.find('table, .alert').remove();
        
        // Hide loading animation and search container when modal closes
        $tableContainer.find('.safeguard-loading').addClass('d-none');
        
        // Hide search container as well
        const $searchContainer = $('#step2-safeguard-selection .safeguard-search-container');
        $searchContainer.addClass('d-none');
    });

    // Reset modal to initial state
    function resetModal() {
        modalCurrentStep = 1;
        modalSelectedProject = null;
        modalSelectedProjectName = null;
        modalIsEditMode = false;
        
        // Clear global tracking
        window.modalSafeguardSelections = [];
        window.modalUserAssignments = {};
        
        // Show step 1, hide step 2
        $('#step1-project-selection').show();
        $('#step2-safeguard-selection').hide();
        $('#step1-buttons').show();
        $('#step2-buttons').hide();
        
        // Initialize Select2 for project selector if not already initialized
        console.log('=== PROJECT DROPDOWN INITIALIZATION ===');
        const $modalSelector = $('#modalProjectSelector');
        console.log('Modal selector element:', $modalSelector);
        console.log('Modal selector HTML:', $modalSelector[0] ? $modalSelector[0].outerHTML : 'Element not found');
        console.log('Number of options in dropdown:', $modalSelector.find('option').length);
        
        // Log all available options
        $modalSelector.find('option').each(function(index, option) {
            console.log('Option ' + index + ':', {
                value: option.value,
                text: option.text,
                selected: option.selected
            });
        });
        
        // Destroy existing Select2 instance if it exists
        if ($modalSelector.hasClass('select2-hidden-accessible')) {
            console.log('Destroying existing Select2 instance...');
            $modalSelector.select2('destroy');
        }
        
        // Check if select2 is available
        if (typeof $.fn.select2 === 'undefined') {
            console.error('Select2 is not loaded! Make sure select2-js is enqueued.');
            return;
        }
        
        // Initialize Select2 for project selector
            console.log('Initializing Select2 for modal project selector...');
            $modalSelector.select2({
                placeholder: "Choose an assessment...",
                width: '100%',
                dropdownParent: $('#projectAssociationsModal'),
                allowClear: false,
                minimumResultsForSearch: 0
            });
            console.log('✓ Select2 initialized successfully');
        
        // Reset form elements
        $('#modalProjectSelector').val('').trigger('change');
        $('#proceedToStep2').prop('disabled', true);
        $('#saveProjectOnly').prop('disabled', true);
        $('#selectedProjectName').text('');
        
        // Properly clear and reset the safeguard table container
        const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
        
        // Destroy any existing DataTables
        $tableContainer.find('table').each(function() {
            if ($.fn.DataTable.isDataTable(this)) {
                $(this).DataTable().destroy();
            }
        });
        
        // Remove dynamic content but preserve loading animation
        $tableContainer.find('table, .alert').remove();
        
        // Hide loading animation and search container for initial state
        $tableContainer.find('.safeguard-loading').addClass('d-none');
        
        // Hide search container as well
        const $searchContainer = $('#step2-safeguard-selection .safeguard-search-container');
        $searchContainer.addClass('d-none');
        
        // Update modal title
        $('#projectAssociationsModalLabel').text('Add Assessment Association');
    }

    // Handle project selection in step 1
    $('#modalProjectSelector').on('change', function() {
        const selectedValue = $(this).val();
        const selectedText = $(this).find('option:selected').text();
        
        console.log('=== PROJECT SELECTOR CHANGE ===');
        console.log('Selected value:', selectedValue);
        console.log('Selected text:', selectedText);
        console.log('Total options available:', $(this).find('option').length);
        
        const hasSelection = !!selectedValue;
        $('#proceedToStep2').prop('disabled', !hasSelection);
        $('#saveProjectOnly').prop('disabled', !hasSelection);
        
        if (selectedValue) {
            console.log('✓ Valid project selected, storing selection');
            modalSelectedProject = selectedValue;
            modalSelectedProjectName = selectedText;
        } else {
            console.log('❌ No project selected, clearing selection');
            modalSelectedProject = null;
            modalSelectedProjectName = '';
        }
    });

    // Handle proceed to step 2 button
    $('#proceedToStep2').on('click', function() {
        if (modalSelectedProject) {
            goToStep2();
        }
    });

    // Handle save project only button
    $('#saveProjectOnly').on('click', function() {
        if (modalSelectedProject) {
            saveProjectOnly();
        }
    });

    // Handle back to step 1 button
    $('#backToStep1').on('click', function() {
        goToStep1();
    });

    // Navigate to step 2
    function goToStep2() {
        modalCurrentStep = 2;
        
        // Hide step 1, show step 2
        $('#step1-project-selection').hide();
        $('#step2-safeguard-selection').show();
        $('#step1-buttons').hide();
        $('#step2-buttons').show();
        
        // Ensure back button is visible in normal workflow
        $('#backToStep1').show();
        
        // Update project name display
        $('#selectedProjectName').text(modalSelectedProjectName);
        
        // Show loading animation immediately when transitioning to step 2
        const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
        console.log('goToStep2: Table container found:', $tableContainer.length);
        
        const $loadingElement = $tableContainer.find('.safeguard-loading');
        console.log('goToStep2: Loading element found:', $loadingElement.length);
        console.log('goToStep2: Loading element classes before:', $loadingElement.attr('class'));
        
        $loadingElement.removeClass('d-none');
        console.log('goToStep2: Loading element classes after removing d-none:', $loadingElement.attr('class'));
        
        $tableContainer.find('table, .alert').addClass('d-none');
        
        // Load safeguards for the selected project
        loadSafeguardsForModalStep2();
    }

    // Navigate to step 1
    function goToStep1() {
        modalCurrentStep = 1;
        
        // Show step 1, hide step 2
        $('#step1-project-selection').show();
        $('#step2-safeguard-selection').hide();
        $('#step1-buttons').show();
        $('#step2-buttons').hide();
        
        // Properly clear step 2 data
        const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
        
        // Destroy any existing DataTables
        $tableContainer.find('table').each(function() {
            if ($.fn.DataTable.isDataTable(this)) {
                $(this).DataTable().destroy();
            }
        });
        
        // Remove dynamic content but preserve loading animation
        $tableContainer.find('table, .alert').remove();
        
        // Hide loading animation and search container when going back to step 1
        $tableContainer.find('.safeguard-loading').addClass('d-none');
        
        // Hide search container as well
        const $searchContainer = $('#step2-safeguard-selection .safeguard-search-container');
        $searchContainer.addClass('d-none');
    }

    // Load safeguards for step 2 using the dedicated function from safeguard-management.js
    function loadSafeguardsForModalStep2() {
        const evidenceId = getPostIdFromBodyClass();
        const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
        const $searchContainer = $('#step2-safeguard-selection .safeguard-search-container');
        
        console.log('loadSafeguardsForModalStep2: Delegating to loadSafeguardsForModal for project:', modalSelectedProject);
        
        // Use the dedicated modal function from safeguard-management.js
        if (typeof window.loadSafeguardsForModal === 'function') {
            window.loadSafeguardsForModal(modalSelectedProject, evidenceId, $tableContainer, $searchContainer);
        } else {
            console.error('loadSafeguardsForModal function not available from safeguard-management.js');
        }
    }

    // Handle save project association
    $('#saveProjectAssociation').on('click', function() {
        saveProjectAssociation();
    });

    // Smart assignment processing: update existing records instead of remove/create
    function processSmartAssignments(newAssignments, existingAssignments) {
        console.log('=== SMART ASSIGNMENT PROCESSING: Starting ===');
        console.log('New assignments:', newAssignments);
        console.log('Existing assignments:', existingAssignments);
        
        const assignmentsToCreate = [];
        const assignmentsToUpdate = [];
        const assignmentsToRemove = [];
        
        // Filter out assignments with invalid assignment IDs first
        const validExistingAssignments = existingAssignments.filter(assignment => {
            const isValidId = assignment.assignmentID && 
                            assignment.assignmentID !== '{assignmentID}' && 
                            assignment.assignmentID !== '%7BassignmentID%7D' &&
                            assignment.assignmentID.length > 10;
            
            if (!isValidId) {
                console.log('SMART PROCESSING: Filtering out invalid assignment ID:', assignment.assignmentID);
            }
            
            return isValidId;
        });
        
        console.log('SMART PROCESSING: Valid existing assignments count:', validExistingAssignments.length, 'out of', existingAssignments.length);
        
        // Group existing assignments by safeguard ID for easier lookup
        const existingBySafeguard = {};
        validExistingAssignments.forEach(existing => {
            if (!existingBySafeguard[existing.safeguardID]) {
                existingBySafeguard[existing.safeguardID] = [];
            }
            existingBySafeguard[existing.safeguardID].push(existing);
        });
        
        // Process each new assignment
        newAssignments.forEach(newAssignment => {
            const safeguardId = newAssignment.safeguardId;
            const existingForSafeguard = existingBySafeguard[safeguardId] || [];
            
            console.log(`SMART PROCESSING: Processing safeguard ${safeguardId}`);
            console.log(`SMART PROCESSING: Existing assignments for this safeguard:`, existingForSafeguard);
            
            // Check if there's an existing assignment that can be updated
            let existingToUpdate = null;
            
            // Look for any existing assignment for this safeguard to update
            console.log(`SMART PROCESSING: Looking for existing assignment to update for safeguard ${safeguardId}`);
            console.log(`SMART PROCESSING: New assignment assignedTo:`, newAssignment.assignedTo, typeof newAssignment.assignedTo);
            console.log(`SMART PROCESSING: Existing assignments for this safeguard:`, existingForSafeguard.map(e => ({
                assignmentID: e.assignmentID,
                assignedTo: e.assignedTo,
                assignedToName: e.assignedToName,
                assignedToType: typeof e.assignedTo
            })));
            
            existingToUpdate = existingForSafeguard.find(existing => {
                // Convert both to numbers for comparison
                const existingAssignedTo = existing.assignedTo ? parseInt(existing.assignedTo, 10) : null;
                const newAssignedTo = newAssignment.assignedTo ? parseInt(newAssignment.assignedTo, 10) : null;
                
                console.log(`SMART PROCESSING: Comparing existing.assignedTo (${existing.assignedTo}, type: ${typeof existing.assignedTo}) with new.assignedTo (${newAssignment.assignedTo}, type: ${typeof newAssignment.assignedTo})`);
                console.log(`SMART PROCESSING: Converted - existing: ${existingAssignedTo}, new: ${newAssignedTo}`);
                
                // Check for exact match
                if (existingAssignedTo === newAssignedTo) {
                    console.log(`SMART PROCESSING: Exact match found!`);
                    return true;
                }
                
                // Check for unassigned cases
                if ((existingAssignedTo === null || existingAssignedTo === undefined) && 
                    (newAssignedTo === null || newAssignedTo === undefined)) {
                    console.log(`SMART PROCESSING: Both unassigned match found!`);
                    return true;
                }
                
                // Check for unassigned by name
                if (existing.assignedToName === 'Unassigned' && 
                    (newAssignedTo === null || newAssignedTo === undefined)) {
                    console.log(`SMART PROCESSING: Unassigned by name match found!`);
                    return true;
                }
                
                // NEW: Check if we're updating from unassigned to assigned (or vice versa)
                // This handles the case where an unassigned safeguard becomes assigned
                if ((existingAssignedTo === null || existingAssignedTo === undefined || existing.assignedToName === 'Unassigned') && 
                    newAssignedTo !== null && newAssignedTo !== undefined) {
                    console.log(`SMART PROCESSING: Updating from unassigned to assigned - MATCH FOUND!`);
                    return true;
                }
                
                // NEW: Check if we're updating from assigned to unassigned
                if (existingAssignedTo !== null && existingAssignedTo !== undefined && 
                    (newAssignedTo === null || newAssignedTo === undefined)) {
                    console.log(`SMART PROCESSING: Updating from assigned to unassigned - MATCH FOUND!`);
                    return true;
                }
                
                return false;
            });
            
            if (existingToUpdate) {
                console.log(`SMART PROCESSING: Found existing assignment to update:`, existingToUpdate);
                assignmentsToUpdate.push({
                    assignmentId: existingToUpdate.assignmentID,
                    assignmentData: {
                        ...newAssignment,
                        dateTime: existingToUpdate.dateTime // Preserve original timestamp
                    }
                });
            } else {
                // No existing assignment found, create new one
                console.log(`SMART PROCESSING: No existing assignment found, will create new assignment`);
                assignmentsToCreate.push(newAssignment);
            }
        });
        
        // Find existing assignments that are no longer needed (not in new assignments)
        validExistingAssignments.forEach(existing => {
            const safeguardId = existing.safeguardID;
            const existingAssignedTo = existing.assignedTo ? parseInt(existing.assignedTo, 10) : null;
            
            // Check if this specific user assignment still exists in the new assignments
            const hasMatchingNewAssignment = newAssignments.some(newAssignment => {
                const newAssignedTo = newAssignment.assignedTo ? parseInt(newAssignment.assignedTo, 10) : null;
                return newAssignment.safeguardId === safeguardId && 
                       existingAssignedTo === newAssignedTo;
            });
            
            if (!hasMatchingNewAssignment) {
                console.log(`SMART PROCESSING: Existing assignment no longer needed, marking for removal:`, existing);
                console.log(`SMART PROCESSING: Safeguard: ${safeguardId}, User: ${existingAssignedTo}, AssignedToName: ${existing.assignedToName}`);
                assignmentsToRemove.push(existing);
            }
        });
        
        console.log('=== SMART ASSIGNMENT PROCESSING: Results ===');
        console.log('Assignments to create:', assignmentsToCreate.length);
        console.log('Assignments to update:', assignmentsToUpdate.length);
        console.log('Assignments to remove:', assignmentsToRemove.length);
        console.log('Create list:', assignmentsToCreate);
        console.log('Update list:', assignmentsToUpdate);
        console.log('Remove list:', assignmentsToRemove);
        
        return {
            create: assignmentsToCreate,
            update: assignmentsToUpdate,
            remove: assignmentsToRemove
        };
    }

    // Process smart assignment operations (create, update, remove)
    function processSmartAssignmentOperations(smartProcessing, callback) {
        console.log('=== PROCESSING SMART ASSIGNMENT OPERATIONS ===');
        console.log('Operations to perform:', smartProcessing);
        
        let totalOperations = smartProcessing.create.length + smartProcessing.update.length + smartProcessing.remove.length;
        let completedOperations = 0;
        let failedOperations = 0;
        
        if (totalOperations === 0) {
            console.log('No operations to perform');
            if (callback) callback(true);
            return;
        }
        
        console.log(`Total operations to perform: ${totalOperations}`);
        
        // Process removals first
        smartProcessing.remove.forEach((assignment, index) => {
            console.log(`Removing assignment ${index + 1}/${smartProcessing.remove.length}:`, assignment);
            
            window.safeguardAssignment.removeAssignment(
                assignment.projectID,
                assignment.safeguardID,
                assignment.evidenceID,
                assignment.assignedTo || 'unassigned'
            );
            
            // For now, assume removal succeeds (we'll improve error handling later)
            completedOperations++;
            checkCompletion();
        });
        
        // Process updates
        smartProcessing.update.forEach((updateOperation, index) => {
            console.log(`Updating assignment ${index + 1}/${smartProcessing.update.length}:`, updateOperation);
            
            window.safeguardAssignment.updateAssignment(
                updateOperation.assignmentId,
                updateOperation.assignmentData,
                function(success) {
                    if (success) {
                        console.log(`Update ${index + 1} completed successfully`);
                        completedOperations++;
                    } else {
                        console.error(`Update ${index + 1} failed`);
                        failedOperations++;
                    }
                    checkCompletion();
                }
            );
        });
        
        // Process creates
        smartProcessing.create.forEach((assignment, index) => {
            console.log(`Creating assignment ${index + 1}/${smartProcessing.create.length}:`, assignment);
            
            // Create individual assignment using the existing createMultipleAssignments logic
            const requestData = {
                action: 'safeguard_assignment',
                subaction: 'assign',
                nonce: window.evidenceData.safeguard_assignment_nonce,
                projectId: assignment.projectId,
                safeguardId: assignment.safeguardId,
                evidenceId: assignment.evidenceId,
                assignedBy: assignment.assignedBy
            };
            
            // Only add assignedTo if it's not null
            if (assignment.assignedTo !== null && assignment.assignedTo !== undefined) {
                requestData.assignedTo = assignment.assignedTo;
            }
            
            // Only add dateTime if it's provided
            if (assignment.dateTime !== null && assignment.dateTime !== undefined) {
                requestData.dateTime = assignment.dateTime;
            }
            
            jQuery.ajax({
                url: window.evidenceData.ajax_url,
                type: 'POST',
                data: requestData,
                success: function(response) {
                    if (response.success) {
                        console.log(`Create ${index + 1} completed successfully`);
                        completedOperations++;
                    } else {
                        console.error(`Create ${index + 1} failed:`, response.data);
                        failedOperations++;
                    }
                    checkCompletion();
                },
                error: function(xhr, status, error) {
                    console.error(`Create ${index + 1} failed:`, error);
                    failedOperations++;
                    checkCompletion();
                }
            });
        });
        
        function checkCompletion() {
            console.log(`Progress: ${completedOperations + failedOperations}/${totalOperations} operations complete`);
            
            if (completedOperations + failedOperations === totalOperations) {
                console.log('=== ALL SMART OPERATIONS COMPLETE ===');
                console.log(`Completed: ${completedOperations}, Failed: ${failedOperations}`);
                
                const success = failedOperations === 0;
                if (callback) callback(success);
            }
        }
    }

    // Save the project association
    function saveProjectAssociation() {
        const evidenceId = getPostIdFromBodyClass();
        const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
        
        console.log('saveProjectAssociation: Starting save process');
        console.log('saveProjectAssociation: Evidence ID:', evidenceId);
        console.log('saveProjectAssociation: Project:', modalSelectedProject);
        console.log('saveProjectAssociation: Table container:', $tableContainer);
        
        // Show loading state
        const $saveButton = $('#saveProjectAssociation');
        const originalText = $saveButton.html();
        $saveButton.prop('disabled', true).html('<i class="fas fa-spinner fa-spin me-1"></i> Saving...');
        
        // Get the evidence slug from the post ID first
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_evidence_id_from_post',
                post_id: evidenceId,
                nonce: evidenceData.safeguard_assignment_nonce
            },
            success: function(response) {
                console.log('get_evidence_id_from_post response:', response);
                if (response.success && response.data) {
                    const evidenceSlug = response.data;
                    console.log('saveProjectAssociation: Evidence slug:', evidenceSlug);
                    
                    // Get current safeguards for this project using the new safeguard assignment system
                    $.ajax({
                        url: evidenceData.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'safeguard_assignment',
                            subaction: 'get_evidence_assignments',
                            evidence_id: evidenceSlug,
                            nonce: evidenceData.safeguard_assignment_nonce
                        },
                        success: function(assignmentsResponse) {
                            console.log('saveProjectAssociation: Current assignments response:', assignmentsResponse);
                            
                            let existingSafeguards = [];
                            let existingAssignments = [];
                            if (assignmentsResponse.success && assignmentsResponse.data) {
                                // Filter assignments for this specific project
                                const projectAssignments = assignmentsResponse.data.filter(assignment => 
                                    assignment.projectID === modalSelectedProject
                                );
                                existingSafeguards = projectAssignments.map(assignment => assignment.safeguardID);
                                existingAssignments = projectAssignments;
                            }
                            console.log('saveProjectAssociation: Existing safeguards:', existingSafeguards);
                            console.log('saveProjectAssociation: Existing assignments:', existingAssignments);
                            
                            // Get newly selected safeguards from global tracking (normalize to strings)
                            const newlySelectedSafeguards = (window.modalSafeguardSelections || []).map(id => String(id));
                            console.log('saveProjectAssociation: Newly selected safeguards from global tracking:', newlySelectedSafeguards);
                            
                            // Get unchecked safeguards that were previously selected (need to remove them)
                            // Compare existing assignments with current global selections to find what was unchecked
                            const uncheckedPreviouslySelected = [];
                            existingSafeguards.forEach(existingId => {
                                const existingIdStr = String(existingId);
                                if (!window.modalSafeguardSelections.includes(existingIdStr)) {
                                    uncheckedPreviouslySelected.push(existingIdStr);
                                }
                            });
                            console.log('saveProjectAssociation: Unchecked previously selected:', uncheckedPreviouslySelected);
                            
                            // Use global selections as the final safeguards (they already include all selections across pages)
                            const finalSafeguards = newlySelectedSafeguards; // This is already from global tracking
                            
                            console.log('saveProjectAssociation: Final safeguards from global tracking:', finalSafeguards);
                            console.log('saveProjectAssociation: Final safeguards types:', finalSafeguards.map(id => typeof id));
                            
                            // Collect user assignments from select2 dropdowns
                            // Use global tracking instead of DOM traversal to handle DataTable pagination
                            const userAssignments = [];
                            console.log('=== DEBUG: Starting assignment collection ===');
                            console.log('Existing assignments:', existingAssignments);
                            console.log('Global safeguard selections:', window.modalSafeguardSelections);
                            console.log('Global user assignments:', window.modalUserAssignments);
                            
                            // Get all selected safeguards from global tracking
                            const selectedSafeguards = window.modalSafeguardSelections || [];
        // console.log('💾 SAVE FUNCTION - Global selections:', window.modalSafeguardSelections);
        // console.log('💾 SAVE FUNCTION - Global user assignments:', window.modalUserAssignments);
                            console.log('💾 SAVE FUNCTION - Selected safeguards from global tracking:', selectedSafeguards);
                            
                            // Process each selected safeguard
                            selectedSafeguards.forEach(safeguardId => {
                                const safeguardIdStr = String(safeguardId);
                                console.log(`=== DEBUG: Processing safeguard ${safeguardIdStr} ===`);
                                console.log(`=== DEBUG: finalSafeguards contains check: ${finalSafeguards.includes(safeguardIdStr)} ===`);
                                
                                // Only create assignments for safeguards that are in finalSafeguards
                                if (finalSafeguards.includes(safeguardIdStr)) {
                                    // Get user assignments for this safeguard from global tracking
                                    const safeguardUserAssignments = window.modalUserAssignments?.[safeguardIdStr] || [];
                                    console.log(`User assignments for safeguard ${safeguardIdStr}:`, safeguardUserAssignments);
                                    
                                    if (safeguardUserAssignments.length > 0) {
                                        // Create an assignment for each selected user
                                        safeguardUserAssignments.forEach(userId => {
                                            console.log(`--- DEBUG: Processing user ${userId} for safeguard ${safeguardIdStr} ---`);
                                            
                                            // Check if this specific assignment already exists to preserve its original dateTime
                                            // Convert userId to number for comparison since existing assignments have numeric assignedTo
                                            const userIdNum = parseInt(userId, 10);
                                            const existingAssignment = existingAssignments.find(assignment => 
                                                assignment.safeguardID === safeguardIdStr && 
                                                assignment.assignedTo === userIdNum
                                            );
                                            
                                            console.log('Existing assignment found:', existingAssignment);
                                            console.log('userId (string):', userId, 'type:', typeof userId);
                                            console.log('userIdNum (number):', userIdNum, 'type:', typeof userIdNum);
                                            
                                            const assignmentData = {
                                                projectId: modalSelectedProject,
                                                safeguardId: safeguardIdStr,
                                                evidenceId: evidenceSlug,
                                                assignedTo: userIdNum, // Use the numeric version for consistency
                                                assignedBy: evidenceData.current_user_id
                                            };
                                            
                                            // Only preserve dateTime if this specific assignment already existed
                                            if (existingAssignment && existingAssignment.dateTime) {
                                                assignmentData.dateTime = existingAssignment.dateTime;
                                                console.log(`Preserving original dateTime: ${existingAssignment.dateTime} (${new Date(existingAssignment.dateTime * 1000).toLocaleString()})`);
                                            } else {
                                                console.log('No existing assignment found or no dateTime - will use current timestamp');
                                            }
                                            
                                            console.log('Final assignment data:', assignmentData);
                                            userAssignments.push(assignmentData);
                                        });
                                    } else {
                                        console.log(`--- DEBUG: Creating unassigned entry for safeguard ${safeguardIdStr} ---`);
                                        
                                        // If no users selected, create unassigned safeguard entry (no assignedTo)
                                        // Check if this unassigned assignment already exists to preserve its original dateTime
                                        const existingAssignment = existingAssignments.find(assignment => 
                                            assignment.safeguardID === safeguardIdStr && 
                                            !assignment.assignedTo
                                        );
                                        
                                        console.log('Existing unassigned assignment found:', existingAssignment);
                                        
                                        const assignmentData = {
                                            projectId: modalSelectedProject,
                                            safeguardId: safeguardIdStr,
                                            evidenceId: evidenceSlug,
                                            assignedTo: null,
                                            assignedBy: evidenceData.current_user_id
                                        };
                                        
                                        // Only preserve dateTime if this specific unassigned assignment already existed
                                        if (existingAssignment && existingAssignment.dateTime) {
                                            assignmentData.dateTime = existingAssignment.dateTime;
                                            console.log(`Preserving original dateTime for unassigned: ${existingAssignment.dateTime} (${new Date(existingAssignment.dateTime * 1000).toLocaleString()})`);
                                        } else {
                                            console.log('No existing unassigned assignment found or no dateTime - will use current timestamp');
                                        }
                                        
                                        console.log('Final unassigned assignment data:', assignmentData);
                                        userAssignments.push(assignmentData);
                                    }
                                } else {
                                    console.log(`Safeguard ${safeguardIdStr} not in finalSafeguards, skipping`);
                                    console.log(`=== DEBUG: safeguardId "${safeguardIdStr}" not found in finalSafeguards [${finalSafeguards.map(id => `"${id}"`).join(', ')}] ===`);
                                }
                            });
                            
                            console.log('=== DEBUG: Final user assignments array ===');
                            console.log('User assignments:', userAssignments);
                            
                            // Log what's being removed vs what's being created
                            console.log('=== DEBUG: Assignment Comparison ===');
                            console.log('Existing assignments to be removed:', existingAssignments);
                            console.log('New assignments to be created:', userAssignments);
                            
                            // Check if any existing assignments are being preserved
                            existingAssignments.forEach(existing => {
                                const isPreserved = userAssignments.some(newAssignment => 
                                    newAssignment.safeguardId === existing.safeguardID &&
                                    newAssignment.assignedTo === existing.assignedTo
                                );
                                console.log(`Assignment ${existing.safeguardID} -> ${existing.assignedTo} (${existing.dateTime}): ${isPreserved ? 'PRESERVED' : 'REMOVED'}`);
                            });
                            
                            console.log('saveProjectAssociation: User assignments:', userAssignments);
                            
                            // Check if we have any real safeguard assignments (non-dummy)
                            const realAssignments = userAssignments.filter(assignment => 
                                assignment.safeguardId !== 'PROJECT_ASSOCIATION_ONLY'
                            );
                            
                            // If no real assignments, create a dummy assignment to maintain project association
                            // But only if one doesn't already exist
                            if (realAssignments.length === 0) {
                                // Check if PROJECT_ASSOCIATION_ONLY already exists in existing assignments
                                const hasProjectAssociation = existingAssignments.some(assignment => 
                                    assignment.safeguardID === 'PROJECT_ASSOCIATION_ONLY'
                                );
                                
                                if (!hasProjectAssociation) {
                                    console.log('saveProjectAssociation: No real assignments and no existing PROJECT_ASSOCIATION_ONLY, creating dummy assignment');
                                    userAssignments.push({
                                        projectId: modalSelectedProject,
                                        safeguardId: 'PROJECT_ASSOCIATION_ONLY',
                                        evidenceId: evidenceSlug,
                                        assignedTo: null,
                                        assignedBy: evidenceData.current_user_id
                                    });
                                } else {
                                    console.log('saveProjectAssociation: PROJECT_ASSOCIATION_ONLY already exists, skipping creation');
                                }
                            }
                            
                            // Filter out dummy assignments from smart processing to avoid unwanted notifications
                            const assignmentsForProcessing = userAssignments.filter(assignment => 
                                assignment.safeguardId !== 'PROJECT_ASSOCIATION_ONLY'
                            );
                            const dummyAssignments = userAssignments.filter(assignment => 
                                assignment.safeguardId === 'PROJECT_ASSOCIATION_ONLY'
                            );
                            
                            console.log('saveProjectAssociation: Real assignments for processing:', assignmentsForProcessing);
                            console.log('saveProjectAssociation: Dummy assignments to handle separately:', dummyAssignments);
                            
                            // Process real assignments smartly: update existing records instead of remove/create
                            const smartProcessing = processSmartAssignments(assignmentsForProcessing, existingAssignments);
                            
                            console.log('saveProjectAssociation: Smart processing results:', smartProcessing);
                            
                            // Process assignments using smart logic
                            if (typeof window.safeguardAssignment !== 'undefined') {
                                processSmartAssignmentOperations(smartProcessing, function(success) {
                                    if (success) {
                                        console.log('Project association saved successfully');
                                        
                                        // Handle dummy assignments separately (silently)
                                        if (dummyAssignments.length > 0) {
                                            console.log('saveProjectAssociation: Creating dummy assignments silently');
                                            window.safeguardAssignment.createMultipleAssignments(dummyAssignments, function(dummySuccess) {
                                                console.log('Dummy assignments processed:', dummySuccess ? 'SUCCESS' : 'FAILED');
                                                
                                                // Close modal and refresh regardless of dummy assignment result
                                                $('#projectAssociationsModal').modal('hide');
                                                
                                                // Refresh the display
                                                if (typeof window.loadProjectAssociationsDisplay === 'function') {
                                                    window.loadProjectAssociationsDisplay();
                                                }
                                                
                                                // Restore button state
                                                $saveButton.prop('disabled', false).html(originalText);
                                            });
                                        } else {
                                            // No dummy assignments needed
                                            $('#projectAssociationsModal').modal('hide');
                                            
                                            // Refresh the display
                                            if (typeof window.loadProjectAssociationsDisplay === 'function') {
                                                window.loadProjectAssociationsDisplay();
                                            }
                                            
                                            // Restore button state
                                            $saveButton.prop('disabled', false).html(originalText);
                                        }
                                    } else {
                                        console.error('Error processing assignments');
                                        alert('Error processing assignments. Please try again.');
                                        // Restore button state
                                        $saveButton.prop('disabled', false).html(originalText);
                                    }
                                });
                            } else {
                                console.error('Safeguard assignment module not available');
                                alert('Safeguard assignment module not available. Please refresh the page and try again.');
                                // Restore button state
                                $saveButton.prop('disabled', false).html(originalText);
                            }
                        },
                        error: function(xhr, status, error) {
                            console.error('Error getting current safeguards:', error);
                            alert('Error getting current safeguards. Please try again.');
                            // Restore button state
                            $saveButton.prop('disabled', false).html(originalText);
                        }
                    });
                } else {
                    console.error('Failed to get evidence slug from post ID');
                    alert('Error getting evidence information. Please try again.');
                    // Restore button state
                    $saveButton.prop('disabled', false).html(originalText);
                }
            },
            error: function(xhr, status, error) {
                console.error('Error getting evidence slug:', error);
                alert('Error getting evidence information. Please try again.');
                // Restore button state
                $saveButton.prop('disabled', false).html(originalText);
            }
        });
    }

    // Save project association only (without safeguards)
    function saveProjectOnly() {
        const evidenceId = getPostIdFromBodyClass();
        
        console.log('saveProjectOnly: Starting save process');
        console.log('saveProjectOnly: Evidence ID:', evidenceId);
        console.log('saveProjectOnly: Project:', modalSelectedProject);
        
        // Show loading state
        const $saveButton = $('#saveProjectOnly');
        const originalText = $saveButton.html();
        $saveButton.prop('disabled', true).html('<i class="fas fa-spinner fa-spin me-1"></i> Saving...');
        
        // Get the evidence slug from the post ID first
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_evidence_id_from_post',
                post_id: evidenceId,
                nonce: evidenceData.safeguard_assignment_nonce
            },
            success: function(response) {
                console.log('saveProjectOnly: get_evidence_id_from_post response:', response);
                if (response.success && response.data) {
                    const evidenceSlug = response.data;
                    console.log('saveProjectOnly: Evidence slug:', evidenceSlug);
                    
                    // Check if PROJECT_ASSOCIATION_ONLY already exists before creating
                    $.ajax({
                        url: evidenceData.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'safeguard_assignment',
                            subaction: 'get_evidence_assignments',
                            evidence_id: evidenceSlug,
                            nonce: evidenceData.safeguard_assignment_nonce
                        },
                        success: function(checkResponse) {
                            if (checkResponse.success && checkResponse.data) {
                                // Check if PROJECT_ASSOCIATION_ONLY already exists for this project
                                const hasProjectAssociation = checkResponse.data.some(assignment => 
                                    assignment.projectID === modalSelectedProject && 
                                    assignment.safeguardID === 'PROJECT_ASSOCIATION_ONLY'
                                );
                                
                                if (hasProjectAssociation) {
                                    console.log('saveProjectOnly: PROJECT_ASSOCIATION_ONLY already exists for this project, skipping creation');
                                    showToast('info', 'Assessment association already exists.');
                                    $('#projectAssociationsModal').modal('hide');
                                    if (typeof window.loadProjectAssociationsDisplay === 'function') {
                                        window.loadProjectAssociationsDisplay();
                                    }
                                    $saveButton.prop('disabled', false).html(originalText);
                                    return;
                                }
                            }
                            
                            // Create a simple project association without any safeguards
                            // This will create an entry in the database that just links the project to the evidence
                            const assignmentData = {
                                projectId: modalSelectedProject,
                                safeguardId: 'PROJECT_ASSOCIATION_ONLY', // Special identifier for project-only associations
                                evidenceId: evidenceSlug,
                                assignedTo: null, // No user assignment
                                assignedBy: evidenceData.current_user_id
                            };
                            
                            console.log('saveProjectOnly: Creating project-only association:', assignmentData);
                            
                            // Use the safeguard assignment module to create the association
                            if (typeof window.safeguardAssignment !== 'undefined') {
                                window.safeguardAssignment.createMultipleAssignments([assignmentData], function(success) {
                                    if (success) {
                                        console.log('Project-only association saved successfully');
                                        
                                        // Close modal
                                        $('#projectAssociationsModal').modal('hide');
                                        
                                        // Refresh the display
                                        if (typeof window.loadProjectAssociationsDisplay === 'function') {
                                            window.loadProjectAssociationsDisplay();
                                        }
                                        
                                        // Show success message in toast
                                        showToast('success', 'Assessment association saved successfully!');
                                    } else {
                                        console.error('Error creating project-only association');
                                        showToast('danger', 'Error creating assessment association. Please try again.');
                                    }
                                    // Restore button state
                                    $saveButton.prop('disabled', false).html(originalText);
                                });
                            } else {
                                console.error('Safeguard assignment module not available');
                                showToast('danger', 'Safeguard assignment module not available. Please refresh the page and try again.');
                                // Restore button state
                                $saveButton.prop('disabled', false).html(originalText);
                            }
                        },
                        error: function(xhr, status, error) {
                            console.error('Error checking existing assignments:', error);
                            showToast('danger', 'Error checking existing assignments. Please try again.');
                            // Restore button state
                            $saveButton.prop('disabled', false).html(originalText);
                        }
                    });
                } else {
                    console.error('Failed to get evidence slug from post ID');
                    showToast('danger', 'Error getting evidence information. Please try again.');
                    // Restore button state
                    $saveButton.prop('disabled', false).html(originalText);
                }
            },
            error: function(xhr, status, error) {
                console.error('Error getting evidence slug:', error);
                showToast('danger', 'Error getting evidence information. Please try again.');
                // Restore button state
                $saveButton.prop('disabled', false).html(originalText);
            }
        });
    }

    // Handle edit project association click
    $(document).on('click', '.edit-project-association', function(e) {
        console.log('Edit button clicked!'); // Debug log
        e.preventDefault();
        e.stopPropagation();
        
        const projectSlug = $(this).data('project-slug');
        const projectName = $(this).data('project-name');
        
        console.log('Editing project association for:', projectSlug, projectName);
        
        // Set up modal for editing
        modalIsEditMode = true;
        modalSelectedProject = projectSlug;
        modalSelectedProjectName = projectName;
        
        // Update modal title for editing
        $('#projectAssociationsModalLabel').text('Edit Assessment Association');
        
        // Skip step 1 and go directly to step 2
        modalCurrentStep = 2;
        $('#step1-project-selection').hide();
        $('#step2-safeguard-selection').show();
        $('#step1-buttons').hide();
        $('#step2-buttons').show();
        
        // Hide the back button in edit mode since there's no step 1 to go back to
        $('#backToStep1').hide();
        
        // Update project name display
        $('#selectedProjectName').text(modalSelectedProjectName);
        
        // Show loading animation immediately before opening modal
        const $tableContainer = $('#step2-safeguard-selection .safeguard-table-container');
        $tableContainer.find('.safeguard-loading').removeClass('d-none');
        $tableContainer.find('table, .alert').addClass('d-none');
        
        // Show the modal
        $('#projectAssociationsModal').modal('show');
        
        // Load safeguards for the project
        loadSafeguardsForModalStep2();
    });

    // Function to load safeguard owners individually
    function loadSafeguardOwnersIndividually(associations, evidenceId) {
        console.log('Loading safeguard owners individually for evidence:', evidenceId);
        
        // Collect all safeguards from all projects
        const allSafeguards = [];
        for (const projectSlug in associations) {
            if (associations.hasOwnProperty(projectSlug)) {
                const safeguards = associations[projectSlug];
                if (Array.isArray(safeguards)) {
                    safeguards.forEach(safeguardId => {
                        if (safeguardId !== 'placeholder') {
                            allSafeguards.push({
                                projectSlug: projectSlug,
                                safeguardId: safeguardId
                            });
                        }
                    });
                }
            }
        }
        
        console.log('Total safeguards to load owners for:', allSafeguards.length);
        
        // Load owners for each safeguard individually
        allSafeguards.forEach(function(safeguardInfo, index) {
            setTimeout(function() {
                loadSingleSafeguardOwner(safeguardInfo.projectSlug, safeguardInfo.safeguardId, evidenceId);
            }, index * 100); // Stagger requests by 100ms to avoid overwhelming the server
        });
    }
    
    // Function to load a single safeguard owner
    function loadSingleSafeguardOwner(projectSlug, safeguardId, evidenceId) {
        console.log('Loading owner for safeguard:', safeguardId, 'in project:', projectSlug);
        
        // Use the new safeguard assignment system
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'safeguard_assignment',
                subaction: 'get_assignments',
                nonce: evidenceData.nonce,
                projectId: projectSlug,
                safeguardId: safeguardId
            },
            success: function(response) {
                if (response.success && response.data && response.data.length > 0) {
                    // Get the most recent assignment for this evidence
                    const evidenceAssignments = response.data.filter(assignment => 
                        assignment.evidenceID === evidenceId
                    );
                    
                    if (evidenceAssignments.length > 0) {
                        // Sort by dateTime and get the most recent
                        evidenceAssignments.sort((a, b) => b.dateTime - a.dateTime);
                        const latestAssignment = evidenceAssignments[0];
                        const owner = latestAssignment.assignedToName || 'Unknown User';
                        
                        // Find the specific row and update it
                        const $row = $(`.safeguard-owner-loading`).closest('tr').filter(function() {
                            return $(this).find('.safeguard-id').text() === safeguardId;
                        });
                        
                        if ($row.length > 0) {
                            const $ownerCell = $row.find('.safeguard-owner');
                            $ownerCell.html(owner);
                            console.log('Updated owner for safeguard:', safeguardId, 'to:', owner);
                        } else {
                            console.warn('Could not find row for safeguard:', safeguardId);
                        }
                    } else {
                        // No assignments for this evidence
                        const $row = $(`.safeguard-owner-loading`).closest('tr').filter(function() {
                            return $(this).find('.safeguard-id').text() === safeguardId;
                        });
                        if ($row.length > 0) {
                            const $ownerCell = $row.find('.safeguard-owner');
                            $ownerCell.html('Not assigned');
                        }
                    }
                } else {
                    // No assignments found
                    const $row = $(`.safeguard-owner-loading`).closest('tr').filter(function() {
                        return $(this).find('.safeguard-id').text() === safeguardId;
                    });
                    if ($row.length > 0) {
                        const $ownerCell = $row.find('.safeguard-owner');
                        $ownerCell.html('Not assigned');
                    }
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error loading owner for safeguard:', safeguardId, error);
                // Update with error state
                const $row = $(`.safeguard-owner-loading`).closest('tr').filter(function() {
                    return $(this).find('.safeguard-id').text() === safeguardId;
                });
                if ($row.length > 0) {
                    const $ownerCell = $row.find('.safeguard-owner');
                    $ownerCell.html('<span class="text-danger">Error loading owner</span>');
                }
            }
        });
    }

    // Make functions available globally
    window.loadProjectAssociationsDisplay = loadProjectAssociationsDisplay;
    window.loadExistingProjectAssociations = loadExistingProjectAssociations;
    window.updateProjectSafeguards = updateProjectSafeguards;

});
